export const AVAILABLE_CREDIT_CARD_COD = [
  6, 4, 7, 8, 48, 49, 50, 55, 56, 74, 75, 24,
];
